import { render, staticRenderFns } from "./project-list-row.vue?vue&type=template&id=c69fdbe6&scoped=true&"
import script from "./project-list-row.vue?vue&type=script&lang=ts&"
export * from "./project-list-row.vue?vue&type=script&lang=ts&"
import style0 from "./project-list-row.vue?vue&type=style&index=0&id=c69fdbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69fdbe6",
  null
  
)

export default component.exports